
import state from './modulePageState.js';
import mutations from './modulePageMutations.js';
import actions from './modulePageActions.js';
import getters from './modulePageGetters.js';

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
